export default "__VITE_ASSET__BXfy82KO__"